import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { motion } from 'framer-motion';
import GradientText from '../shared/GradientText';
import SectionWrapper from '../shared/SectionWrapper';
import { techStack, categoryLabels } from '../../data/techStack';

const TechStackSection: React.FC = () => {
  const categories = Object.keys(categoryLabels) as Array<keyof typeof categoryLabels>;

  return (
    <SectionWrapper id="tech">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <Box sx={{ mb: 10 }}>
          <GradientText variant="h2" sx={{ mb: 3 }}>
            Powered By
          </GradientText>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 480 }}>
            Built on industry-leading technologies from native app to AI to data layer.
          </Typography>
        </Box>
      </motion.div>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        {categories.map((category, catIdx) => {
          const items = techStack.filter((t) => t.category === category);
          return (
            <motion.div
              key={category}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: catIdx * 0.08 }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  fontWeight: 600,
                  letterSpacing: 2,
                  textTransform: 'uppercase',
                  fontSize: '0.7rem',
                  mb: 2,
                }}
              >
                {categoryLabels[category]}
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {items.map((tech) => (
                  <Chip
                    key={tech.name}
                    label={tech.name}
                    sx={{
                      bgcolor: 'rgba(255, 255, 255, 0.04)',
                      color: '#ffffff',
                      fontWeight: 500,
                      fontSize: '0.85rem',
                      py: 2.5,
                      px: 1,
                      border: '1px solid rgba(255, 255, 255, 0.06)',
                      '&:hover': {
                        bgcolor: 'rgba(255, 255, 255, 0.08)',
                        borderColor: 'rgba(255, 255, 255, 0.12)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  />
                ))}
              </Box>
            </motion.div>
          );
        })}
      </Box>
    </SectionWrapper>
  );
};

export default TechStackSection;
